import React, { Component } from 'react';
import { Button, Table, Segment, Header, Form, List, Dimmer, Loader } 
	from 'semantic-ui-react'
//import Search from '../components/search';
import store from '../store/rvwdlist-store';
import { withRouter } from 'react-router-dom';
import {observer} from 'mobx-react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import ReactTable from "react-table";
import * as mobx from 'mobx';


class RvwdList extends Component {

  constructor(props) {
  	super(props);
  	this.state =  {
		  		    visible: false
		         }
  }

  componentDidMount() {
  	store.loadRvwdList();
   }


  renderReactTable() {
		const docs = mobx.toJS(store.reviewedDocs);

		return(
				<ReactTable
					data={docs}
					noDataText="No records found"
					 //filterable
         			 //defaultFilterMethod={(filter, row) =>
           			 //String(row[filter.id]) === filter.value}
					columns = {[
						{ Header: "Document Name", accessor: "docname"}, 
						{ Header: "Description", accessor: "docdescr" },
						{ Header: "Creation Date", accessor: "creationdate" },
						{ Header: "Created By", accessor: "createdby" },
						{ Header: "Review Acknowledgement Date", accessor: "reviewdate" },
					]}
					style={{
						height: '80vh'
					}}
					defaultPageSize={25}
					//className="-striped -highlight"
					showPaginationTop={true}
					showPaginationBottom={false}	 
				/>

		)

	}


  render() {
        return(
	            <div className="user-actions">

	                <div class="title">
	                   <h4 align="left">Reviewed Documents List</h4>
	                </div>
     

            		 {store.loading && (
				          <Segment>
				            <Dimmer active inverted>
				              <Loader inverted>Loading</Loader>
				            </Dimmer>
				          </Segment>
				      )}

					 {this.renderReactTable()}

	            </div>
              )
  }
}

export default withRouter(observer(RvwdList));



// WEBPACK FOOTER //
// ./src/containers/RvwdList.js